var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M17.9993 26.4054V17.9341H20.7243L21.1324 14.6326H17.9993V12.5248C17.9993 11.5691 18.2535 10.9175 19.5671 10.9175L21.2426 10.9169V7.96391C20.9529 7.92384 19.9583 7.83398 18.8013 7.83398C16.3857 7.83398 14.732 9.37247 14.732 12.1981V14.6326H12V17.9341H14.732V26.4054H17.9993Z","fill":"#142470","key":0}),React.createElement("rect",{"x":"1","y":"1","width":"32","height":"32","rx":"16","stroke":"#142470","key":1})]);
}

Facebook.defaultProps = {"width":"34","height":"34","viewBox":"0 0 34 34","fill":"none"};

module.exports = Facebook;

Facebook.default = Facebook;
